import { Component } from '@angular/core';

@Component({
  selector: 'app-now-sell',
  templateUrl: './now-sell.component.html',
  styleUrls: []
})
export class NowSellComponent {
  constructor() {
    window.scrollTo(0, 0);
  }
  page: number = 0;
  imgSrcList = [
    'assets/img/sunum1.jpg',
    'assets/img/sunum2.jpg',
    'assets/img/sunum3.jpg',
    'assets/img/sunum4.jpg',
    'assets/img/sunum5.jpg',
    'assets/img/sunum6.jpg',
    'assets/img/sunum7.jpg',
    'assets/img/sunum8.jpg',
    'assets/img/sunum9.jpg',
    'assets/img/sunum10.jpg',
    'assets/img/sunum11.jpg',
    'assets/img/sunum12.jpg',
  ]
}
